class MultilingualUrl {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    setTimeout(() => {
      const Link = document.querySelectorAll('.link');
      Link.forEach((el) => {
        const dataHref = el.dataset.href;
        el.setAttribute('href', dataHref);
      });
    },500);

  }
}
